import {useCatGroup} from "../features/categories/useCategoryGroup";
import type {
  CategoryEntry,
  CategoryGroupEntryId,
  CategoryGroupId,
  CategoryId,
  GroupId,
  GroupRepo,
} from "./GroupRepo";
import {useIndex} from "./use-index";

export const useSortedCategoryIds = (groupRepo: GroupRepo, catGroupId: CategoryGroupId) => {
  return useIndex<CategoryGroupEntryId>(catGroupId, groupRepo.indexes, "sortedCategoryEntries");
};

export const useSortedCategories = (groupRepo: GroupRepo, groupId: GroupId) => {
  const catGroup = useCatGroup(groupId, groupRepo);
  const ids = useSortedCategoryIds(groupRepo, catGroup.id);
  const catEntries = groupRepo.CategoryGroupEntries.useGetAll();
  const cats = groupRepo.Categories.useGetAll();
  return ids.map((id) => {
    const entry = catEntries[id];
    return {cat: cats[entry.categoryId], catGroupEntry: entry};
  });
};

export const groupItemsByCategory = <T>(
  items: T[],
  getCategory: (item: T) => CategoryId | null,
  cats: CategoryEntry[]
) => {
  const byCatId = new Map<CategoryId | null, T[]>();
  for (const item of items) {
    const catId = getCategory(item);
    const exist = byCatId.get(catId);
    if (exist) {
      exist.push(item);
    } else {
      byCatId.set(catId, [item]);
    }
  }
  const groups = cats
    .map((cat) => {
      const catItems = byCatId.get(cat.id);
      if (catItems) {
        byCatId.delete(cat.id);
        return {category: cat, elements: catItems};
      }
      return null as any as {category: CategoryEntry | null; elements: T[]};
    })
    .filter(Boolean);
  const leftOverEntries: T[] = [];
  for (const leftOver of byCatId.values()) leftOverEntries.push(...leftOver);
  if (leftOverEntries.length) {
    groups.unshift({elements: leftOverEntries, category: null});
  }
  return groups;
};
